import React from 'react';
import './promo.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useSelector } from 'react-redux';

const PromoBanner = (props) => {
  const settingsData = useSelector((state) => state.subscriptionData.settingData);
  
  return (
    <div
      className="promo-banner alert alert-warning border border-success border-2 rounded-0 text-dark mb-0"
      role="alert"
    >
      <div className="container py-2 text-center">
        <h5 className="fw-bold text-success mb-1">
          <span role="img" aria-label="fire">🔥</span> Don’t Miss This — {settingsData?.trialPeriod}s {settingsData?.trailsubPackages?.includes('combo')? 'Advanced' : settingsData?.trailsubPackages?.includes('updates')? 'Compliance Essential': settingsData?.trailsubPackages?.includes('pro')? 'Professional' : ''}, Free!
        </h5>
        <p className="mb-2">
          Buy any policy licence today and get <strong>{settingsData?.trialPeriod}s of Cloudoc {settingsData?.trailsubPackages?.includes('combo')? 'Advanced' : settingsData?.trailsubPackages?.includes('updates')? 'Compliance Essential': settingsData?.trailsubPackages?.includes('pro')? 'Professional' : ''} free</strong> — with live
          updates and smart document control included.
        </p>
        <ul className="list-inline mb-3">
          <li className="list-inline-item"><span role="img" aria-label="check mark">✅</span> Instant access</li>
          <li className="list-inline-item">📄 Always up-to-date</li>
          <li className="list-inline-item"><span role="img" aria-label="document management">🗂️</span> Document management</li>
          <li className="list-inline-item">🛡️ Regulator-compliant</li>
        </ul>
        <button onClick={() => props.history.push({ pathname: '/policies-procedures', state: { country: 'england' } })} className="btn btn-warning fw-bold text-dark px-4">
          📥 Get My Policies Now!
        </button>
      </div>
    </div>
  );
};

export default PromoBanner;
